import { render, staticRenderFns } from "./PublicRooms.vue?vue&type=template&id=53acf088&scoped=true&lang=html&"
import script from "./PublicRooms.vue?vue&type=script&lang=js&"
export * from "./PublicRooms.vue?vue&type=script&lang=js&"
import style0 from "./PublicRooms.vue?vue&type=style&index=0&id=53acf088&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53acf088",
  null
  
)

export default component.exports